
import { Component, Vue } from 'vue-property-decorator'

@Component({
    name: 'create-detail-layout'
})
export default class extends Vue {
}
